import { useTranslation } from 'react-i18next'

import { putanjaPoteza, putanjaS, VIEWBOX } from '../lib/logo'

/**
 * Znak marke na ekranu — isti crtež koji nosi ikona aplikacije (`lib/logo.ts`).
 *
 * Boja dolazi iz `currentColor`, dakle iz tokena teme (§17): na noiru je
 * mjedena, na svijetlom admin panelu tamna, a tenant tema ih mijenja bez ijedne
 * izmjene ovdje.
 */
export function Znak({ velicina = 40 }: { velicina?: number }) {
  const { t } = useTranslation()

  return (
    <svg
      width={velicina}
      height={velicina}
      viewBox={VIEWBOX}
      role="img"
      aria-label={t('app.name')}
      className="text-champagne"
    >
      <path d={putanjaPoteza()} fill="currentColor" />
      <path d={putanjaS()} fill="currentColor" />
    </svg>
  )
}
